import { UseFormReturn } from 'react-hook-form';
import { IuserInfo } from 'reducer/common/userInfo';
import { IlogRecordQuery } from 'view/Layout/Project/components/LogRecordModal/type';
import {
  IretailerSetupOrder,
  QueryOrderForm,
  QueryOrderFormDetail,
} from '../../init';

export interface ResultSecionProps {
  _logRecordData: [
    IlogRecordQuery[],
    React.Dispatch<React.SetStateAction<IlogRecordQuery[]>>,
  ];

  _retailerSetup: [
    IretailerSetupOrder,
    React.Dispatch<React.SetStateAction<IretailerSetupOrder>>,
  ];
  _showLogRecordModal: [boolean, React.Dispatch<React.SetStateAction<boolean>>];

  formReturnDetail: UseFormReturn<QueryOrderFormDetail>;

  userInfoReducer: IuserInfo;
  handleSearch: (
    page?: number,
    pageSize?: number,
    doLoading?: boolean,
  ) => (input: QueryOrderForm | QueryOrderFormDetail) => Promise<void>;
}

export interface IorderDownloadPreviewRequest {
  retailerId: string;
  userRole: string;
  orderSeqNos: string[];
  sort: {
    desc: string;
    property: string;
  }[];
  previewShowPrice: boolean;
  downloadShowPrice: boolean;
}

export enum OrderDownloadPreviewRequest {
  retailerId = 'retailerId',
  userRole = 'userRole',
  orderSeqNos = 'orderSeqNos',
  sort = 'sort',
  previewShowPrice = 'previewShowPrice',
  downloadShowPrice = 'downloadShowPrice',
}
